<template>
	<div class="top-session-button__container" style="display: flex">
		<!-- <locale-switcher /> -->
		<button
			v-if="authenticated && hasKyc && canViewTransactions && !env.displayTopSessionBalanceInfo"
			class="top-session-button button button__primary"
			@click="openDeposit"
		>
			{{ $t('account.deposit') }}
		</button>

		<router-link
			v-if="!authenticated"
			class="top-session-button button button__secondary outline link"
			style="margin-right: 2px"
			:to="{
				name: 'login',
				query: {
					next: $route.query.next ? $route.query.next : $route.fullPath,
				},
			}"
			>{{ $t('session.login') }}</router-link
		>
		<router-link
			v-if="!authenticated"
			class="top-session-button button button__secondary link"
			:to="{	name: 'register',
				query: {
					next: $route.query.next ? $route.query.next : $route.fullPath,
				},
			}
			"
			>{{ $t('session.register') }} </router-link
		>
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			:enable-stacking="true"
			stack-behavior="stack"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div style="padding: 5px;">
				<network-saver
					v-if="showNetworkSelector == true"
					:available-networks="availableNetworks"
					:deposit-amount="depositAmount"
					@close="closeBottomSheet"
				/>


				<deposit
					v-else
					:user="user"
					@close="closeBottomSheet" />
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import Deposit from "../Session/Account/Deposit.vue";
import NetworkSaver from "../Session/Account/NetworkSaver.vue";
import LocaleSwitcher from "./LocaleSwitcher.vue";
import BottomSheet from "../v2/Shared/BottomSheet.vue"

export default {
	components: { Deposit, NetworkSaver, LocaleSwitcher, BottomSheet },
	data() {
		return {
			canShowBottomSheet: false,
			showNetworkSelector: false,
			depositAmount: null,
			network:"",
			error:null
		};
	},
	created() {
		let vm = this;
		vm.$root.$on("close-deposit-open-network-selector", vm.closeDepositOpenNetworkSelector);
	},
	beforeDestroy() {
		let vm = this;
		vm.$root.$off("close-deposit-open-network-selector", vm.closeDepositOpenNetworkSelector)
	},
	methods: {
		async refreshDetails() {
			let vm = this;
			const token = vm.$auth.getToken();
			if (!token) {
				vm.$auth.logout();
				vm.$notifications.add({
					message: this.$t("session.expired"),
					type: "error",
					title: this.$t("session.session-expired"),
					duration: 5000,
				});
				await vm.$router.replace("/login");
				return;
			}
			return await vm.$axios.post(`${BASE_URL}balance`, { token })
		},
		openDeposit() {
			let vm = this;
			vm.refreshDetails().then((response) => {
				vm.network = response.data.data.network;
				if(this.supportsV2Payments()){
					if (
						!this.env.disabledFeatures.includes("network") &&
						(this.network == null || this.network == "")
					) {
						this.canShowBottomSheet = true;
						this.showNetworkSelector = true;
					}else{
						this.$router.push("/profile/deposit");
					}
				}else{
					this.canShowBottomSheet = true;
					this.showNetworkSelector = false;
					setTimeout(() => {
						const el = document.querySelector(
							"#app > div:nth-child(8) > div > div.card > div.contents > div > div > div > div.input__container.deposit.input.account__section__input > input"
						);
						utils.focusAndOpenKeyboard(el, 0);
						this.$refs.bottomSheet.recalculateHeight();
					}, 300);
				}
			})
				.catch((error) => {
					console.log(error)
					if (error.response.status == 401) {
						vm.$auth.logout();
						vm.$notifications.add({
							message: this.$t("session.expired"),
							type: "error",
							title: this.$t("session.session-expired"),
							duration: 5000,
						});
						vm.$router.replace("/login");
					}
				})
				.finally(() => {
					vm.loading = false;
				});
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			if(this.supportsV2Payments()) {
				this.showNetworkSelector = this.network == '';
			}else{
				this.showNetworkSelector = false;
			}

			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
				setTimeout(() => {
					this.$refs.bottomSheet.recalculateHeight();
				}, 750);
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
				this.showNetworkSelector = false;
				this.$emit("is-transacting", false);
			});
		},
		closeDepositOpenNetworkSelector(amount = null){
			if(amount !== null){
				this.depositAmount = amount;
			}
			this.showNetworkSelector = true;
		}
	},
	computed: {
		authenticated() {
			return this.$store.getters.authenticated;
		},
		canViewTransactions() {
			let vm = this;
			if (this.env.kyc.required) {
				if (
					vm.kycData.status &&
					vm.kycData.status !== undefined &&
					vm.kycData.status == "3"
				) {
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		},
		availableNetworks(){
			return this.env.networkProviders;
		},
		kycData() {
			return this.$store.getters.user.kyc;
		},
		hasKyc() {
			if (this.env.kyc.required === true) {
				return this.$store.getters.user.has_kyc;
			} else {
				return true;
			}
		},
		user() {
			let user = this.$store.getters.user;
			user.bonus = this.bonus;
			user.points = this.points;

			return user;
		},
	},
};
</script>

<style lang="scss" scoped>
.top-session-button {
	padding: 8px 15px;
	font-size: var(--font-small);
	border-radius: 8px;
	font-weight: var(--font-weight-medium);
	&__container {
		.button__primary {
			border: 0px;
		}
		.button__secondary {
			border: 0px;
			&.outline {
				font-weight: var(--font-weight-bold);
			}
		}
		margin-right: 10px;
	}
}
</style>
